// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { Col, Row } from 'angieslist-react-components';
import { Track, urlCatalog } from 'angieslist-app-platform';
import Experiment from 'angieslist-app-platform/lib/common/experiment/v3/Experiment';
import { AdvertiserOnlyPillComponent } from '../AdvertiserOnlyPill';
import DealsModal from './DealsModal';
import './NewActivityCard.scss';

type Props = {
  isAdvertiser: boolean,
  serviceProviderId: string,
  dealsCount: number,
  quotesCount: number,
  messagesCount: number,
  reviewsCount: number,
  inbox: Object,
  name: string,
  phoneNumber: string
};

class NewActivityCard extends React.PureComponent<Props> {
  props: Props;
  render(): Element<"div"> {
    const {
      isAdvertiser, serviceProviderId, dealsCount, quotesCount,
      messagesCount, reviewsCount, inbox, name, phoneNumber,
    } = this.props;

    const getMessageUrl = () => {
      if (inbox.isInboxEnabled) {
        return urlCatalog.office.inbox(serviceProviderId);
      }
      return `${urlCatalog.office.leadBoard(serviceProviderId)}?newMessages=true`;
    };

    return (
      <div id="New-Activity-Card">
        <Experiment name="combinedLeadsAndMessages" />
        <Row className="card-v4-container">

          <Col xs={6} lg={3} className="card-wrapper">
            <div className="individual-card">
              <span className="card-title">Deals</span>
              <Choose>
                <When condition={!isAdvertiser}>
                  <AdvertiserOnlyPillComponent customText="Advertiser Only" addClass="pull-right" />
                </When>
                <Otherwise>
                  <span className="pull-right">
                    <Track>
                      <a
                        className="text-info"
                        id="new-activity--view-deals-link"
                        href={urlCatalog.office.leadBoard(serviceProviderId)}
                      >
                      View All
                      </a>
                    </Track>
                  </span>
                </Otherwise>
              </Choose>
              <div className="card-body">
                <Choose>
                  <When condition={isAdvertiser}>
                    <Choose>
                      <When condition={dealsCount > 0}>
                        <span className="activity-present">
                          { dealsCount }
                        </span>
                      </When>
                      <Otherwise>
                        <div className="activity-absent">No new deals claimed</div>
                      </Otherwise>
                    </Choose>
                  </When>
                  <Otherwise>
                    <div className="activity-absent">
                      <DealsModal
                        ctaText="Learn how deals can help your business"
                        returnLinkOnly
                        name={name}
                        phoneNumber={phoneNumber}
                      />
                    </div>
                  </Otherwise>
                </Choose>
              </div>
            </div>
          </Col>

          <Col xs={6} lg={3} className="card-wrapper">
            <div className="individual-card">
              <span className="card-title">Leads</span>
              <span className="pull-right">
                <Track>
                  <a
                    className="text-info"
                    id="new-activity--view-quotes-link"
                    href={urlCatalog.office.leadBoard(serviceProviderId)}
                  >
                  View All
                  </a>
                </Track>
              </span>
              <div className="card-body">
                <Choose>
                  <When condition={quotesCount > 0}>
                    <span className="activity-present">
                      { quotesCount }
                    </span>
                  </When>
                  <Otherwise>
                    <div className="activity-absent">No new leads</div>
                  </Otherwise>
                </Choose>
              </div>
            </div>
          </Col>

          <Col xs={6} lg={3} className="card-wrapper">
            <div className="individual-card">
              <span className="card-title">Messages</span>
              <span className="pull-right">
                <Track>
                  <a
                    className="text-info"
                    id="new-activity--view-messages-link"
                    href={getMessageUrl()}
                  >
                    View All
                  </a>
                </Track>
              </span>
              <div className="card-body">
                <Choose>
                  <When condition={messagesCount > 0}>
                    <span className="activity-present">
                      { messagesCount }
                    </span>
                  </When>
                  <Otherwise>
                    <div className="activity-absent">No new messages</div>
                  </Otherwise>
                </Choose>
              </div>
            </div>
          </Col>

          <Col xs={6} lg={3} className="card-wrapper">
            <div className="individual-card">
              <span className="card-title">Reviews</span>
              <span className="pull-right">
                <Track>
                  <a
                    className="text-info"
                    id="new-activity--view-reviews-link"
                    href={urlCatalog.office.reviews(serviceProviderId)}
                  >
                    View All
                  </a>
                </Track>
              </span>
              <div className="card-body">
                <Choose>
                  <When condition={reviewsCount > 0}>
                    <span className="activity-present">
                      { reviewsCount }
                    </span>
                  </When>
                  <Otherwise>
                    <div className="activity-absent">
                      <Track>
                        <a
                          id="new-activity--request-reviews-link"
                          className="text-info pointer"
                          href={urlCatalog.office.requestReviews(serviceProviderId)}
                        >
                          <span className="pointer">
                            Request Reviews
                          </span>
                        </a>
                      </Track>
                    </div>
                  </Otherwise>
                </Choose>
              </div>
            </div>
          </Col>

        </Row>
      </div>
    );
  }
}

export default (compose(
  connect(state => ({
    inbox: state.inbox,
  })),
  pure,
)(NewActivityCard): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/NewActivityCard.js